import { render, staticRenderFns } from "./PaymentLoading.vue?vue&type=template&id=4ba4670c&scoped=true&"
import script from "./PaymentLoading.vue?vue&type=script&lang=js&"
export * from "./PaymentLoading.vue?vue&type=script&lang=js&"
import style0 from "./PaymentLoading.vue?vue&type=style&index=0&id=4ba4670c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba4670c",
  null
  
)

export default component.exports